/**
 * Data attribute every `ModalFooter` renders, so styles outside the MF modal shell can find the
 * footer, e.g. to pin it to the bottom of a legacy full-screen modal on phones.
 */
export const modalFooterAttribute = 'data-mf-modal-footer';
